// extracted by mini-css-extract-plugin
export default {"container":"LeadingVisual-module__container--lXqCp","hasNewActivity":"LeadingVisual-module__hasNewActivity--cLEiZ","visualContainer":"LeadingVisual-module__visualContainer--xKxNe"};